var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", filterable: "", placeholder: "文章" },
                  model: {
                    value: _vm.paramsData.announce_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "announce_id", $$v)
                    },
                    expression: "paramsData.announce_id"
                  }
                },
                _vm._l(_vm.announceList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.title, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "是否隐藏" },
                  model: {
                    value: _vm.paramsData.state,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "state", $$v)
                    },
                    expression: "paramsData.state"
                  }
                },
                _vm._l(_vm.state, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-date-picker", {
                attrs: {
                  "value-format": "yyyy-MM-dd",
                  type: "daterange",
                  align: "right",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期"
                },
                model: {
                  value: _vm.date,
                  callback: function($$v) {
                    _vm.date = $$v
                  },
                  expression: "date"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          attrs: { data: _vm.pagingList, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "title", label: "文章标题" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [_vm._v(" " + _vm._s(row.announce.title) + " ")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "content", label: "评论内容" }
          }),
          _c("el-table-column", {
            attrs: { prop: "support_count", label: "支持数量" }
          }),
          _c("el-table-column", {
            attrs: { prop: "against_count", label: "反对数量" }
          }),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "评论时间" }
          }),
          _c("el-table-column", {
            attrs: { prop: "nick_name", label: "用户信息" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v("名称：" + _vm._s(row.user_info.nick_name))
                    ]),
                    _c("div", [
                      _vm._v("角色ID:" + _vm._s(row.user_info.role_id))
                    ]),
                    _c("div", [
                      _vm._v("服务器名称：" + _vm._s(row.user_info.server_name))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "reply_user_info", label: "回复用户信息" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.reply_user_info
                      ? _c("div", [
                          _c("div", [
                            _vm._v(
                              "名称：" +
                                _vm._s(row.reply_user_info.nick_name || "/")
                            )
                          ]),
                          _c("div", [
                            _vm._v(
                              "角色ID：" +
                                _vm._s(row.reply_user_info.role_id || "/")
                            )
                          ]),
                          _c("div", [
                            _vm._v(
                              "服务器名称：" +
                                _vm._s(row.reply_user_info.server_name || "/")
                            )
                          ])
                        ])
                      : _c("div", [_vm._v("/")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", { attrs: { prop: "ip", label: "IP" } }),
          _c("el-table-column", {
            attrs: { prop: "reports", label: "举报列表" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.reports.length
                      ? _c(
                          "div",
                          {
                            staticStyle: { color: "#409EFF" },
                            on: {
                              click: function($event) {
                                return _vm.viewOpen(row.reports)
                              }
                            }
                          },
                          [_vm._v("查看")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "操作", width: "150px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: {
                          click: function($event) {
                            return _vm.changState(row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(row.state == 1 ? "隐藏" : "显示"))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.del([row])
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.pagingList.length
        ? _c("el-pagination", {
            staticClass: "x-c",
            attrs: {
              layout: "total, prev, pager, next,jumper",
              "current-page": _vm.paramsData.page,
              total: _vm.totalNum,
              "page-size": _vm.paramsData.page_size
            },
            on: { "current-change": _vm.getList }
          })
        : _vm._e(),
      _c(
        "el-drawer",
        {
          attrs: { title: "详情", visible: _vm.drawer },
          on: {
            "update:visible": function($event) {
              _vm.drawer = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "contentHtml", staticStyle: { padding: "0 20px" } },
            _vm._l(_vm.content, function(item, index) {
              return _c("div", { staticStyle: { "padding-bottom": "10px" } }, [
                _c("span", [
                  _vm._v("角色ID:" + _vm._s(JSON.parse(item.user_info).role_id))
                ]),
                _c("span", { staticStyle: { "margin-left": "30px" } }, [
                  _vm._v(
                    "举报人名称:" + _vm._s(JSON.parse(item.user_info).nick_name)
                  )
                ]),
                _c("div", [_vm._v("举报原因:" + _vm._s(item.reason))]),
                index !== _vm.content.length - 1
                  ? _c("div", {
                      staticStyle: {
                        "border-bottom": "1px dashed #e8e8e8",
                        margin: "10px 0"
                      }
                    })
                  : _vm._e()
              ])
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }